import { createInertiaApp } from '@inertiajs/react'
import type { ResolvedComponent } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import '../styles/app.css'

const pages = import.meta.glob<{ default: ResolvedComponent }>('../pages/**/*.tsx')

createInertiaApp({
  resolve: (name) => {
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Inertia page not found: ${name}`)
    }
    return page().then((module) => module.default)
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
